import { render, staticRenderFns } from "./196.vue?vue&type=template&id=b24ef96a&scoped=true&"
var script = {}
import style0 from "./196.vue?vue&type=style&index=0&id=b24ef96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24ef96a",
  null
  
)

export default component.exports